import { render } from "./TopSellingProductsChart.vue?vue&type=template&id=0eecab51&ts=true"
import script from "./TopSellingProductsChart.vue?vue&type=script&lang=ts"
export * from "./TopSellingProductsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__